import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '@/services/firebase';
import { clearHiddenChatHistory, hideChatHistory } from '@/services/appPinSession';
import { clearAllLocalOnlyMessages } from '@/services/chatLocalOnlyStore';

const FUNCTIONS_REGION = process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION?.trim() || 'europe-west1';

type WipeResult = {
  ok: boolean;
  wipedThreads: number;
  deletedMessages: number;
  timedOut: boolean;
};

let wipeCallable: ReturnType<typeof httpsCallable<Record<string, never>, WipeResult>> | null = null;

function getWipeCallable() {
  if (!wipeCallable) {
    wipeCallable = httpsCallable<Record<string, never>, WipeResult>(
      getFunctions(app, FUNCTIONS_REGION),
      'wipeOwnChatHistory'
    );
  }
  return wipeCallable;
}

/** Hide history immediately, then delete thread content on the server. Contacts stay. */
export async function runDuressChatHistoryWipe(uid: string): Promise<void> {
  hideChatHistory(uid);
  try {
    await clearAllLocalOnlyMessages();
  } catch {
    /* IndexedDB may be unavailable */
  }
  try {
    let timedOut = true;
    for (let i = 0; i < 3 && timedOut; i += 1) {
      const res = await getWipeCallable()({});
      timedOut = res.data?.timedOut === true;
    }
    if (!timedOut) {
      clearHiddenChatHistory(uid);
    }
  } catch (e) {
    console.error('wipeOwnChatHistory failed', e);
  }
}
